import API, { baseURL } from './api';
import { getSucursalInfo } from './auth';

// Client for sge_infantil_core's routes/frequency.js (mounted at /api/frequency).
// FREQUENCY_TABLE is the multi-purpose "Nível/Curso" entity — reused across the
// whole app (Turmas' educationLevel, Disciplinas'/Avaliações' levelId, and here
// as the actual "Cursos/Classes/Níveis" catalog screen). Uses the plain POST /,
// PUT /:id, DELETE /remove/:id, GET /:sucursalId routes — not the parallel
// /create, /update/:id, /extended/* variants also present in the backend.
export async function listFrequencies(sucursalId) {
  const id = sucursalId || getSucursalInfo()?.id || 1;
  return API.get(`${baseURL}api/frequency/${id}`);
}

export async function createFrequency(payload) {
  const sucursalId = getSucursalInfo()?.id || 1;
  return API.post(`${baseURL}api/frequency`, { sucursalId, ...payload });
}

export async function updateFrequency(id, payload) {
  return API.put(`${baseURL}api/frequency/${id}`, payload);
}

export async function deleteFrequency(id) {
  return API.delete(`${baseURL}api/frequency/remove/${id}`);
}
